export const TEST_IDS = {
  REPORT_FILTERS: "filters-div",
  VALUE_CHANGE: "value-change",
  SIGN_OUT_LINK: "sign-out-link",
  BREADCRUMB_HOME: "breadcrumb-home",
  PROFILE_DROPDOWN: "profile-dropdown",
  STATUS_INDICATOR: "status-indicator",
  USER_PROFILE_LINK: "user-profile-link",
  AVERAGE_RATING_TOGGLE: "average-rating-toggle",
};
